<template>
   <div id="map" style="height: 530px; width: 100%;"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import LocationService from '@/services/location-service'
import { useToast } from 'primevue/usetoast'

const props = defineProps(['origin', 'destination', 'driveType'])
const emit = defineEmits(['distance', 'time', 'match'])
const { getPlaceLocality } = LocationService()
const toast = useToast()

let map : any
let directionsService : any
let directionsRenderer : any
let featureLayer: any

const initMap = async () => {

   const center = { lat: -34.397, lng: 150.644 }
   map = new (window as any).google.maps.Map(document.getElementById('map'), {
      center: center,
      zoom: 8,
   })

   const citymap = {
      chicago: {
         center: { lat: 41.878, lng: -87.629 }
      }
   }

   if (props.driveType == 'distance') {

      directionsService = new (window as any).google.maps.DirectionsService()
      directionsRenderer = new (window as any).google.maps.DirectionsRenderer()
      directionsRenderer.setMap(map)
   } else if (props.driveType == 'hourly') {
      
      if (props.origin) {

         const placesService = new (window as any).google.maps.places.PlacesService(map)
         placesService.getDetails({ placeId: props.origin }, function (place: any, status: any) {
            if (status === "OK" && place.geometry && place.geometry.location) {

               const location = place.geometry.location
               getPlaceLocality(props.origin, location.lat(), location.lng()).then((data) => {

                  if (!data.data.success) {
                     console.log('Error in fetching location bounds')
                     var map = new (window as any).google.maps.Map(document.getElementById('map'), {
                        zoom: 13,
                        center: location
                     })

                     emit('match', 'not-found')
                  } else {

                     const bd = data.data.match.bounds
   
                     const centerLat = (parseFloat(bd.north_east_lat) + parseFloat(bd.south_west_lat)) / 2;
                     const centerLng = (parseFloat(bd.north_east_lng) + parseFloat(bd.south_west_lng)) / 2;
                     const center = new (window as any).google.maps.LatLng(centerLat, centerLng)
   
                     var bounds: any = new (window as any).google.maps.LatLngBounds(
                        new (window as any).google.maps.LatLng(parseFloat(bd.south_west_lat), parseFloat(bd.south_west_lng)),
                        new (window as any).google.maps.LatLng(parseFloat(bd.north_east_lat), parseFloat(bd.north_east_lng))
                     )
   
                     var map = new (window as any).google.maps.Map(document.getElementById('map'), {
                        zoom: 10,
                        center: bounds.getCenter()
                     })

                     // new (window as any).google.maps.Marker({
                     //    map,
                     //    position: location,
                     // })

                     new (window as any).google.maps.Marker({
                        map,
                        position: center,
                     })

                     emit('match', data.data.match)
                  }
               })
            }
         })
      }
   }

   if (props.driveType == 'distance') {
      calculateAndDisplayRoute()
   }
}

const calculateDistanceAndTime = (response: any) => {

   const route = response.routes[0];
   const leg = route.legs[0];

   const distanceText = leg.distance.text
   const durationText = leg.duration.text

   emit('distance', distanceText, 'distance')
   emit('time', durationText, 'time')
}

const calculateAndDisplayRoute = () => {
   const startPlaceId = props.origin
   const endPlaceId = props.destination

   if (startPlaceId && endPlaceId && startPlaceId != '' && endPlaceId != '') {

      directionsService.route({
            origin: { placeId: startPlaceId },
            destination: { placeId: endPlaceId },
            travelMode: 'DRIVING',
         },(response: any, status: any) => {
            if (status === 'OK') {
   
               directionsRenderer.setDirections(response);
               calculateDistanceAndTime(response)
            } else {
               
               if (status === 'ZERO_RESULTS') {
                  toast.add({
                     severity: 'info',
                     summary: 'No Road Route Found',
                     detail: 'We couldn\'t calculate a driving route between these locations. They might be on different continents or separated by water.',
                     life: 5000
                  })
               } else {
                  toast.add({
                     severity: 'error',
                     summary: 'Map Error',
                     detail: 'Directions request failed due to ' + status,
                     life: 3000
                  })
               }
            }
         }
      )
   }
}

watch(() => props.origin, (newVallue, oldValue) => {
   initMap()
})

watch(() => props.destination, (newVallue, oldValue) => {
   initMap()
})

onMounted(function(){

   initMap()
});
</script>